import { ActionTree } from "vuex";
import { State } from "./state";
import { create, filter, findOne, update, findAll } from "@/store/Crud/functions/actions";

export default <ActionTree<State, any>>{
  create,
  findAll,
  findOne,
  update,
  filter,
};
